export default __webpack_public_path__ + "static/media/phoneSuccess.7ecb799f.png";